export const assessmentPath: any = {
  Scorecard: "scorecard",
  "Criticality Score": "criticality_score",
  Sonarqube: "sast",
  Codeql: "sast",
  SBOM: "sbom",
  Fossology: "license-compliance",
  "Fuzz Report": "fuzz",
  Snyk: "snyk",
  Cryptography: 'cryptography'
};

export const assessmentReport: any = {
  Scorecard: "scorecard",
  "Criticality Score": "criticality_score",
  Sonarqube: "sonarqube",
  Codeql: "codeql",
  SBOM: "sbom",
  Fossology: "fossology",
  "Fuzz Report": "fuzz",
  Snyk: "snyk",
  cryptography: 'cryptography'
};
